// @flow

import React, { useCallback } from 'react';
import find from 'lodash/fp/find';
import propEq from 'lodash/fp/propEq';
import connect from '@active/awe-ui-core/lib/hoc/connect';
import NoRecord from 'components/NoRecord/NoRecord';

import {
  getEvent,
  getResultType,
} from '../../duck/selector';
import {
  changeResultType as changeResultTypeAction,
} from '../../duck/duck';
import Dashboard from '../Dashboard/Dashboard';

type Props = {
  noRecord: boolean,
  resultType: string,
  changeResultType: Function,
}

export const PhysicalRace = ({
  noRecord,
  resultType,
  changeResultType,
}: Props) => {
  const handleResultTypeChange = useCallback((newType: string) => {
    if (resultType !== newType) {
      changeResultType(newType);
    }
  }, [ resultType, changeResultType ]);

  if (noRecord) {
    return (
      <div className="page">
        <NoRecord />
      </div>
    );
  }

  return (
    <Dashboard resultType={resultType} onChangeResultType={handleResultTypeChange} />
  );
};

const mapState = (state) => {
  const event = getEvent(state);

  if (!event) {
    return ({ noRecord: true });
  }

  const { routes } = event.toJSON();

  return ({
    resultType: getResultType(state),
    noRecord: !find(propEq('virtual', false))(routes),
  });
};

const PhysicalRaceContainer = connect(mapState, {
  changeResultType: changeResultTypeAction,
})(PhysicalRace);

export default PhysicalRaceContainer;
